import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { IconContext } from 'react-icons';
import qs from 'qs';
import fetch from 'isomorphic-fetch';
import * as Sentry from '@sentry/react';
import 'lazysizes';

import clientConfig from '../common/config';
import createStore from '../common/redux/store/createStore';
import routes from '../common/routes';
import { authUser } from '../common/redux/modules/user';

// Sentry.io
Sentry.init({
  dsn: !!clientConfig.hostname
    ? // DEV
      'https://6a32f4adb1000dc54dadcfe391c8d21c@o4507293944119296.ingest.de.sentry.io/4507338990026832'
    : // PROD
      'https://1c3728d1c5ece8ca327fa132d094a909@o4507293944119296.ingest.de.sentry.io/4507338991665232',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: !!clientConfig.hostname ? 1.0 : 0.1,
  // tracePropagationTargets: ['localhost'],
  // Session Replay
  replaysSessionSampleRate: !!clientConfig.hostname ? 1.0 : 0.1,
  replaysOnErrorSampleRate: !!clientConfig.hostname ? 1.0 : 0.1,
});

// Get cartId and cartToken from querystring
// To pre-set cart in case of Abandoned Cart Email
// This overwrites the current localStorage values, if present
const parsedQuery = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});
const { cartId, cartToken } = parsedQuery;
if (cartId && cartToken) {
  localStorage.setItem('token', null);
  localStorage.setItem('cartId', cartId);
  localStorage.setItem('cartToken', cartToken);
}

let INITIAL_STATE = {};
if (!window.__INITIAL_STATE__) {
  setInitialState().then(init);
} else {
  init();
}

if (!!window.__INITIAL_STATE__) {
  localStorage.setItem('storeId', window.__INITIAL_STATE__.store.data.storeId);
}

async function setInitialState() {
  const response = await fetch(
    `${clientConfig.apiBaseHost + clientConfig.apiBasePath}/store?hostname=${
      req.hostname
    }`
  );

  if (response.ok) {
    const data = await response.json();
    INITIAL_STATE = {
      store: {
        data: {
          ...data,
          loghiTemplate: {
            ...data.loghiTemplate,
          },
        },
      },
    };
  }
}

function init() {
  // Initialize Redux store from server state
  const initialState = window.__INITIAL_STATE__ || INITIAL_STATE;
  const store = createStore({
    ...initialState,
    layout: {
      isMobile: window.innerWidth <= 768,
    },
  });

  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      store.dispatch(authUser(user));
    }
  } catch (e) {}

  // GOOGLE ANALYTICS - LOG PAGE VIEW
  function logPageView() {
    // ReactGA.set({ page: window.location.pathname });
    // ReactGA.ga('send', 'pageview');

    if (window.appendAwin && typeof window.appendAwin === 'function') {
      window.appendAwin();
    }
  }

  ReactDOM.render(
    <Provider store={store}>
      <IconContext.Provider value={{ style: { verticalAlign: 'middle' } }}>
        <Router
          history={browserHistory}
          routes={routes}
          onUpdate={logPageView}
        />
      </IconContext.Provider>
    </Provider>,
    document.getElementById('root')
  );
}
